const module = { name: 'Fandango/debugLog', exports: {} }; const exports = module.exports;



const mockable = {
    events: []
}
function push(level) {
    const args = [].slice.call(this);
    if (!args.length) {
        return;
    }
    const event = {
        level,
        values: args.length === 1 ? args[0] : args,
    };
    return mockable.events.push(event);
}
function clear() {
    mockable.events.splice(0);
}
function extendForTools() {
    window.Fandango.debugLogDevs = {
        get() {
            return mockable.events;
        },
        set(events) {
            mockable.events = events;
        }
    };
}
function extendLegacy(publicInterface, sectionName) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[sectionName]) {
        Fandango[sectionName] = publicInterface;
    }
}


const mockableExports = Object.assign(mockable, {
    log() {
        push.call(arguments, 'log');
    },
    info() {
        push.call(arguments, 'info');
    },
    error() {
        push.call(arguments, 'error');
    },
    warn() {
        push.call(arguments, 'warn');
    },
    clear
})
module.exports = mockableExports;
extendLegacy(module.exports, 'debug');
extendLegacy(module.exports, 'bizIntl');
extendForTools();
export default module.exports;